import { IconButton, Stack, Tooltip, Typography } from '@mui/material';
import React, { useEffect, useState } from 'react';
import CusLabelSelect from '../../../components/material-ui/CusLabelSelect';
import { API_GAMEKIT } from '../../../api/gamekit';
import { useTranslation } from 'react-i18next';
import { IconRefresh } from '@tabler/icons-react';
import useColor from '../../../hooks/site/useColor';
import TypographyText from '../../../components/material-ui/table/TypographyText';
import GambitProvidersList from './GambitProvidersList';
import CusButton from '../../../components/material-ui/CusButton';
import { options0To100Percent } from '../../../enums/enums';
import { API_SETTING } from '../../../api/setting';
import InfoDialog from '../../../components/shared/InfoDialog';
import useToast from '../../../hooks/useToast';

export default function AggregatorContent() {
  const { t } = useTranslation();
  const { primary, action } = useColor();
  const { successToast } = useToast();

  const [updateDisabled, setUpdateDisabled] = useState(false);
  const [openInstallEvery, setOpenInstallEvery] = useState(false);
  const [selectSource, setSelectSource] = useState('');
  const [selectAllPercent, setSelectAllPercent] = useState('');
  const [sourceOptions, setSourceOptions] = useState([]);
  const [providersHas, setProvidersHas] = useState({});

  const updateSource = () => {
    API_SETTING.provider.source
      .list()
      .then((e) => {
        const list = e.data.list || {};
        const source = Object.keys(list);
        const sources = source?.map((el) => ({ label: list[el]?.name, value: el })) || [];

        setSourceOptions([...sources]);
        setSelectSource(sources[0]?.value);
      })
      .catch(console.error);
  };

  useEffect(() => {
    updateSource();
  }, []);

  const onInstallEvery = () => {
    const newProviderHash = {};

    for (const providerName in providersHas) {
      if (providersHas.hasOwnProperty(providerName)) {
        const curProvider = providersHas[providerName];

        newProviderHash[providerName] = {
          ...curProvider,
          percent: +selectAllPercent
        };
      }
    }

    API_SETTING.provider.option
      .set({ sourceId: selectSource, providerList: newProviderHash })
      .then(() => {
        successToast('Information updated successfully');
        setProvidersHas(newProviderHash);
      })
      .catch(console.error);

    setOpenInstallEvery(false);
  };

  return (
    <>
      <Stack gap={2}>
        <Stack
          gap={1}
          direction={'row'}
          justifyContent={'space-between'}
          alignItems={'center'}
          flexWrap={'wrap'}>
          <Stack gap={1} direction={'row'} alignItems={'center'}>
            <CusLabelSelect
              label={'Pool'}
              options={sourceOptions}
              value={selectSource}
              onChange={setSelectSource}
              isRow
            />
          </Stack>

          <Stack direction={'row'} gap={1} alignItems={'center'}>
            <CusLabelSelect
              label={''}
              value={selectAllPercent}
              onChange={(val) => setSelectAllPercent(val)}
              options={options0To100Percent}
            />
            <CusButton
              text="Install for everyone"
              disabled={!selectAllPercent}
              variant="outlined"
              onClick={() => setOpenInstallEvery(true)}
            />
          </Stack>
        </Stack>

        <GambitProvidersList
          sourceId={selectSource}
          providersHas={providersHas}
          setProvidersHas={setProvidersHas}
        />
      </Stack>

      <InfoDialog
        open={openInstallEvery}
        onClose={() => setOpenInstallEvery(false)}
        title={`${t('Select commission for everyone', { commission: `${selectAllPercent}%` })}`}
        maxWidth="xs"
        onSaveClick={onInstallEvery}
        saveText="Set for everyone"
      />
    </>
  );
}
